import {Component, OnDestroy, OnInit} from '@angular/core';

import {ShareModule} from './shared/shareModule/share.module';
import {Location} from '@angular/common';
import './../assets/css/index.css';
declare var $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: [
        './app.component.css',
    ],
})
export class AppComponent implements OnInit, OnDestroy {

    constructor(
        private _shareService: ShareModule,

    ) {
    }


    ngOnInit() {

    }

    ngOnDestroy() {

    }

}
